<template>
  <a :href="applyLink" target="_blank" class="mswcreators__btn-apply"> Apply </a>
</template>
<script setup lang="js">
const applyLink = 'https://www.research.net/r/3RLV99H'
</script>
